import React from 'react';
import { PromocodeViewModel } from '@common/model/billing/promocode';
import { PromocodeActivatedMessage, PromocodeActivatedMessageProps } from './activatedMessage';
import { ActivatePromoCodeFormProps, ActivatePromocodeForm } from './activateForm';

export interface PromocodeSwitchFormProps {
  promocode?: PromocodeViewModel;
  ActivatedMessage?: (props: PromocodeActivatedMessageProps) => JSX.Element | null;
  ActivateForm?: (props: ActivatePromoCodeFormProps) => JSX.Element | null;
  activateFormProps?: Partial<ActivatePromoCodeFormProps>;
}
export const PromocodeSwitchForm: React.FC<PromocodeSwitchFormProps> = ({
  promocode,
  activateFormProps,
  ActivateForm = ActivatePromocodeForm,
  ActivatedMessage = PromocodeActivatedMessage,
}) => {
  return promocode ? <ActivatedMessage promocode={promocode} /> : <ActivateForm {...activateFormProps} />;
};
